import React from "react";
import { Card, Row, Col } from "react-bootstrap";
import HeroSection from "../../utilities/HeroSection.jsx";
// import "./Spirituality.css"; // Import your CSS file for styling

import image1 from "./assets/images/jesus.png";
import image2 from "./assets/images/mary.png";
import image4 from "./assets/images/mary-2.png";
import image3 from "./assets/images/paul.png";
import image5 from "./assets/images/spirituality1.png";
import image6 from "./assets/images/jesus2.png";

function Spirituality({ banners, isLoading, error }) {
  const spirituality = banners ? banners["who we are - our spirituality"] : [];
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <HeroSection banners={spirituality} isLoading={isLoading} error={error} />
      <Card className="spirituality-card">
        <Card.Title className="text-maroon font-header py-3 h1">
          Our Spirituality
        </Card.Title>

        <Card.Body className="text-start spirituality-content">
          <Row>
            <Col xs={12} md={6}>
              <Card.Img src={image1} className="spirituality-image" />
            </Col>
            <Col xs={12} md={6} className="divider align-middle">
              After the experience in Susa, some major developments marked their
              lives. The young women made their religious profession on 22nd
              July 1922, hence giving them a certainty of carrying out their
              mission. On 15th March 1929, they were approved by Bishop Re,
              Bishop of Alba. On 15th March 1953, the Congregation was erected
              as an Institute of Pontifical Right, and its Constitutions
              received final approval.
            </Col>
          </Row>

          <Row className="my-4 d-none d-md-flex">
            <Col xs={12} md={6}>
              <Card.Img src={image5} className="spirituality-image" />
            </Col>
            <Col xs={12} md={6}>
              <Card.Img src={image6} className="spirituality-image" />
            </Col>
          </Row>

          <Row>
            <Col xs={12} md={6}>
              <Card.Img src={image2} className="spirituality-image" />
            </Col>
            <Col xs={12} md={6} className="divider align-middle">
              Mary Queen of the Apostles <br />
              Modeling ourselves on Mary, whom we honor as the Queen of Apostles
              and of every apostolate, we bring Jesus to all humanity with great
              fervor, proclaiming the Truth that saves, the Way that leads to
              the Father, and his Life of grace.
            </Col>
          </Row>

          <Row className="my-4">
            <Col xs={12} >
              <Card.Img src={image4} className="spirituality-image" />
            </Col>
          </Row>

          <Row>
            <Col xs={12} md={6}>
              <Card.Img src={image3} className="spirituality-image" />
            </Col>
            <Col xs={12} md={6} className="divider align-middle">
              St Paul Apostle <br />
              We are striving to reach the same goal as the Apostle Paul: "It is
              no longer I who live but Christ who lives in me". To attain this
              objective, we draw light and support from the Eucharist, the Word
              of God, daily prayer and fraternal communion, all of which give us
              the strength we need to carry out our many-faceted apostolate.
              They are also the fonts that help us discern the signs of the
              times so as to respond to the needs of the Church and world.
            </Col>
          </Row>

          <Row className="my-4">
            <Card.Title className="text-maroon font-header py-3 h3 text-center">
              SPIRITUALITY OF THE PAULINE FAMILY
            </Card.Title>
            <Col xs={12} className="divider align-middle">
              <ol className="spirituality-list">
                <li>
                  <p>
                    According to Fr. Alberione, the spirituality of “Jesus
                    Master, Way, Truth, Life” presents an integral view of
                    everything. In this Pauline Method of Jesus Master Way,
                    Truth, Life, there is completeness: It presents the complete
                    Jesus, complete religion, complete human person, complete
                    redemption, complete formation, complete apostolate. Pauline
                    spirituality presents Jesus as truth to believe, Jesus as
                    way to follow and Jesus life to share in. Such devotion,
                    according to Fr. James Alberione, leads the whole
                    person—mind, will, heart—to God.
                  </p>
                </li>

                <li>
                  <p>
                    Blessed James Alberione’s spirituality is founded on the
                    Eucharist and the Word of God. His daily celebration of the
                    Eucharist and the four or five hours he spent in adoration
                    and contemplating the Word of God became the focal point of
                    his day, sustaining an immensely hectic and active apostolic
                    lifestyle. His holistic spirituality responds in a unique
                    way to the yearnings of people today for healing and
                    fulfillment.
                  </p>
                  <p>
                    Today, our society is troubled by a deep spiritual poverty
                    and an inability to integrate the various aspects of life.
                    Each of us has experienced times of fragmentation, when our
                    thoughts lead us one way while our feelings pull us in
                    another direction. When this happens, we tend to ignore our
                    feelings or we act against our better judgment instead of
                    letting our actions take into account both what we feel and
                    what we think. We make decisions based on the “role” we are
                    playing at the moment rather than letting our words and
                    decisions flow from the essence of who we are.
                  </p>
                  <p>
                    Bl. James Alberione’s holistic approach challenges our
                    tendency to break up our lives and to stuff the fragments
                    into separate compartments where they never relate to each
                    other. According to Alberione, Eucharistic adoration is a
                    true encounter with Jesus, Way, Truth, and Life. Jesus who
                    invites us to drop our masks in front of Him and, in the
                    comfort of His love, to come to appreciate and respect our
                    deepest and truest selves. In the security of His love, we
                    can open ourselves to the transforming power of His grace in
                    all the areas of our lives, so that we can gradually become
                    ever more faithful instruments of His love for transforming
                    the world.
                  </p>
                </li>

                <li>
                  <p>
                    “Devotion to Jesus Master sums up and completes all
                    devotions. In fact, it presents Jesus Truth in whom to
                    believe; Jesus Way, who is to be followed; Jesus Life in
                    whom we participate. Speaking of Jesus Master, we must keep
                    in mind a much broader sense. He not only communicates
                    knowledge, but He also transfuses His life into the
                    disciples, making them similar to Himself. He develops the
                    divine life in them and guides them to eternal life.”
                  </p>
                </li>

                <li>
                  <p>
                    In the Eucharist, we encounter the Divine Master in a unique
                    way. For Father Alberione, the Eucharist was the secret,
                    transforming power of his life, and he encouraged all the
                    members of the Pauline Family to center their lives on the
                    Eucharistic Master. Out of humility and wisdom, Alberione
                    insisted that the members of the Pauline family consider
                    Saint Paul as their spiritual father, and thus both
                    Alberione’s spirituality and the family he founded are
                    called “Pauline.” Jesus invites us to share in his own
                    intimate relationship with the Father; and how we are called
                    to listen to the appeals of the Spirit in history today, and
                    to respond in a prophetic way. Alberione’s Pauline
                    spirituality could easily become the keystone of
                    mission-oriented spirituality for all Christians who breathe
                    the culture of communications today.
                  </p>
                </li>
              </ol>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
}

export default Spirituality;
